'use client';

import { Link } from '@mui/material';
import { trackEvent } from '../../../../utils/trackEvent';

type Props = {
  href: string;
  value: string;
  contactType: 'phone' | 'email';
};

const ContactLink = ({ href, value, contactType }: Props) => {
  const track = () => {
    trackEvent('select_content', { content_type: contactType, item_id: value });
  };

  return (
    <Link href={href} onClick={track} onCopy={track}>
      {value}
    </Link>
  );
};

export default ContactLink;
